import { useMediaQuery, useTheme } from '@material-ui/core';

type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

export function useIsMobile(breakpoint: Breakpoint = 'sm') {
	const theme = useTheme();
	return useMediaQuery(theme.breakpoints.down(breakpoint));
}
